import { Dialog } from 'quasar';
import { i18n } from './i18n';

export default async ({ store }) => {
  try {
    store.dispatch('application/fetchVersion');
    store.dispatch('user/initializeUser');
    store.dispatch('location/fetchDeliveryMethods');
    store.dispatch('location/fetchPaymentMethods');
    store.dispatch('application/fetchBackgroundImage');
    store.dispatch('order/fetchLastOrder');
    await store.dispatch('location/fetchLocations');
    await store.dispatch('menu/fetchAll');
  }
  catch (error) {
    Dialog.create({
      title: i18n.t('api.error.bootFailed.title'),
      message: i18n.t('api.error.bootFailed.message', { error }),
    });
  }
  finally {
    if (store.state.location.all.length < 1) {
      store.commit('application/setClosed');
    }
    else {
      store.dispatch('menu/initializeRootCategory', {
        categoryId: store.getters['location/getDefaultLocation'].categoryId,
      });
    }
  }
};
